import { render, staticRenderFns } from "./buyer-label-dialog.vue?vue&type=template&id=77f7e326&scoped=true"
import script from "./buyer-label-dialog.vue?vue&type=script&lang=js"
export * from "./buyer-label-dialog.vue?vue&type=script&lang=js"
import style0 from "./buyer-label-dialog.vue?vue&type=style&index=0&id=77f7e326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7e326",
  null
  
)

export default component.exports